module.exports = __webpack_public_path__ + "static/OTP-6bc65e353fb6191ce07a9fc90a10f994.png";